<template>
  <header class="get-pica-header container">
    <div class="get-pica-header__logo">
      <img :src="picaIconSrc" alt="GetPica" class="get-pica-header__logo-icon">
      <img :src="picaTextSrc" alt="GetPica">
    </div>
    <a :href="b2bUrl" target="_blank" rel="noopener" class="get-pica-header__btn">
      <span>{{ $t('menu.discover_pica') }}</span>
      <Icon name="arrowNarrowUpRight" :width="17" />
    </a>
  </header>
</template>

<script>
import Icon from "@/domain/icon/Icon.vue";
import picaIconSrc from "@/assets/pica-icon.svg";
import picaTextSrc from "@/assets/pica-text.svg";
import {getB2BUrl, metricB2B} from "@/utils";

export default {
  name: "GetPicaHeader",
  components: {Icon},
  computed: {
    picaIconSrc() {
      return picaIconSrc
    },
    picaTextSrc() {
      return picaTextSrc
    },
    b2bUrl() {
      return getB2BUrl(metricB2B.HEADER)
    },
  }
}
</script>

<style scoped lang="scss">
.get-pica-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 16px 28px;

  &__logo {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  &__logo-icon {
    width: 32px;
    height: 32px;
  }

  &__btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background-color: #1a192d;
    border: 1px solid #4e4d64;
    border-radius: 8px;
    padding: 10px 8px 10px 12px;
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.14px;
    text-decoration: none;
    white-space: nowrap;
    line-height: 1.2;

    &:hover {
      color: #ffffff;
      text-decoration: none;
      border-color: #7e7d94;
    }
  }
}
</style>
